export const SET_ORIGINAL_CONFIGURATION = 'SET_ORIGINAL_CONFIGURATION';

export const setOriginalConfiguration = (originalConfiguration) => ({
  type: SET_ORIGINAL_CONFIGURATION,
  originalConfiguration
});

export const SET_CONFIGURATION_LEVEL = 'SET_CONFIGURATION_LEVEL';

export const setConfigurationLevel = (level_visibility: number) => ({
  type: SET_CONFIGURATION_LEVEL,
  level_visibility
});

export const SET_CONFIGURATION_OPTIONCLASSIFICATIONS = 'SET_CONFIGURATION_OPTIONCLASSIFICATION';

export const setConfigurationOptionClassifications = (optionclassifications) => ({
  type: SET_CONFIGURATION_OPTIONCLASSIFICATIONS,
  optionclassifications
});